// extracted by mini-css-extract-plugin
module.exports = {"noBookings":"NoBookings_noBookings__1PfBF"};